/**
 * Check if a Sanity document is a draft
 * Draft documents have IDs that start with "drafts." OR have _isDraft flag set
 */
export function isDraftDocument(
  documentId?: string,
  isDraftFlag?: boolean,
): boolean {
  if (isDraftFlag !== undefined) {
    return isDraftFlag;
  }
  if (!documentId) return false;
  return documentId.startsWith("drafts.");
}
